import React from 'react';

/**
 * @typedef {object} AggregatePercentageChartTooltipProps
 * @property {boolean} [active]
 * @property {Array<*>} [payload]
 * @property {*} [label]
 */

/**
 * @param {AggregatePercentageChartTooltipProps} props
 */
const AggregatePercentageChartTooltip = props => {
  const { active, payload, label } = props;

  if (!active || !payload?.length) {
    return null;
  }

  return (
    <div className='aggregate-percentage-chart-tooltip tooltip'>
      <p>{label}</p>
      {payload.map((entry, index) => {
        if (entry.name === 'range') {
          return null;
        }

        return (
          <p key={`tooltip-item-${index}`} style={{ color: entry.color || entry.stroke }}>
            <span>{entry.name}: </span>
            <span>
              {entry.name === 'Unit' ? `${entry.payload.UnitAggregatePercentage}%` : entry.value}
            </span>
          </p>
        );
      })}
    </div>
  );
};

export default AggregatePercentageChartTooltip;
